var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrid1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "XMLID_1_",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.5,
    height: 15.5,
    viewBox: "0 0 15.5 15.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_11_",
    d: "M0,6.37H6.37V0H0ZM.9.9H5.467V5.467H.9ZM9.13,0V6.37H15.5V0ZM14.6,5.467H10.033V.9H14.6ZM0,15.5H6.37V9.13H0Zm.9-5.467H5.467V14.6H.9ZM9.13,15.5H15.5V9.13H9.13Zm.9-5.467H14.6V14.6H10.033Z",
    fill: "#1383d9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid1);
export default __webpack_public_path__ + "static/media/grid1.446ffcdbf4a32ed4598cfd3c6deeb469.svg";
export { ForwardRef as ReactComponent };